import React from 'react';
// import { Order, OrderItem } from '../../types';
import { Scanner } from '../Scanner';
import { PickListItem } from './PickListItem';
import { BsCamera } from 'react-icons/bs';
import { OutboundOrder, OutboundOrderItem } from '../../../../api/warehouse/generated/src';

interface PickListProps {
  order: OutboundOrder;
  onScanClick: () => void;
  isScanning: boolean;
  onScan: (barcode: string) => void;
  onCloseScanner: () => void;
  itemRefs: React.MutableRefObject<{ [key: string]: HTMLDivElement | null }>;
  expandedItems: Set<string>;
  expandedLocations: Set<string>;
  onItemClick: (item: OutboundOrderItem) => void;
  onToggleItemExpanded: (itemId: string, e: React.MouseEvent) => void;
  onToggleLocationExpanded: (itemId: string, e: React.MouseEvent) => void;
  onOpenBatchModal: (item: OutboundOrderItem) => void;
  onOpenSerialModal: (item: OutboundOrderItem) => void;
  onOpenQtyModal: (item: OutboundOrderItem, e: React.MouseEvent) => void;
  onConfirmStandardPick: (item: OutboundOrderItem) => void;
  onOpenBatchQtyEdit: (item: OutboundOrderItem, batchIndex: number, e: React.MouseEvent) => void;
}

export const PickList: React.FC<PickListProps> = ({
  order,
  onScanClick,
  isScanning,
  onScan,
  onCloseScanner,
  itemRefs,
  expandedItems,
  expandedLocations,
  onItemClick,
  onToggleItemExpanded,
  onToggleLocationExpanded,
  onOpenBatchModal,
  onOpenSerialModal,
  onOpenQtyModal,
  onConfirmStandardPick,
  onOpenBatchQtyEdit,
}) => {
  return (
    <>
      <div className="sticky top-[84px] z-10 mb-4 bg-gray-50">
        <div
          className="bg-white rounded-lg shadow-md p-4"
        >
          <Scanner
            isActive={true}
            scanType="item"
            onScan={onScan}
            onClose={onCloseScanner}
          />
        </div>
        {/* <button
          onClick={onScanClick}
          className="w-full bg-green-600 text-white py-3 px-4 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-green-700 transition shadow-md"
        >
          <BsCamera size={20} />
          Artikel scannen
        </button> */}


      </div>

      <div className="space-y-3">
        {order.items.map(item => {
          const remainingQty = item.requiredQty - item.shippedQty;

          // Skip items that are fully shipped
          if (remainingQty <= 0) return null;

          return (
            <PickListItem
              key={item.id}
              item={item}
              remainingQty={remainingQty}
              isExpanded={expandedItems.has(item.id)}
              isLocationExpanded={expandedLocations.has(item.id)}
              itemRef={el => itemRefs.current[item.id] = el}
              onItemClick={onItemClick}
              onToggleExpanded={onToggleItemExpanded}
              onToggleLocationExpanded={onToggleLocationExpanded}
              onOpenBatchModal={onOpenBatchModal}
              onOpenSerialModal={onOpenSerialModal}
              onOpenQtyModal={onOpenQtyModal}
              onConfirmStandardPick={onConfirmStandardPick}
              onOpenBatchQtyEdit={onOpenBatchQtyEdit}
            />
          );
        })}
      </div>
    </>
  );
};